import log from "loglevel";

function isValidDate(date) {
  return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
}


/**
 * Function to sort alphabetically an array of objects by some specific key.
 *
 * @param {String} property Key of the object to sort.
 */
export function sortBy(property, ascending=false) {
  return function (a,b) {
      const _a = a[property];
      const _b = b[property];
      var result;
      if (_a === null && _b === null) {
        result = 0;
      } else if (_a === null && _b != null) {
        result = -1;
      } else if (_a != null && _b === null) {
        result = 1;
      } else {
        if (isValidDate(_a) && isValidDate(_b)) {
          result = _b - _a;
        } else if ( (typeof _a === 'string' || _a instanceof String) && (typeof _b === 'string' || _b instanceof String) ) { 
          // _a and _b are strings
          result = _a.localeCompare(_b);
        } else if (typeof _a === 'number' && typeof _b === 'number') {
          result = _b - _a; // _a and _b are numbers
        } else {
          const typeOfA = typeof _a;
          const typeOfB = typeof _b;
          log.error(`Unsupported type during comparison for sorting.  A Type: ${typeOfA}, B Type: ${typeOfB}, A: ${_a}, B: ${_b}`);
          throw new Error(`Unsupported type during comparison for sorting.  A Type: ${typeOfA}, B Type: ${typeOfB}, A: ${_a}, B: ${_b}`);
        }
      }
      if (ascending){
        return -1 * result;
      }
      return result;
  }
}
